import { StateCreator } from "zustand";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY} from "../../../base";
import { FetchAutoCompleteLocationType } from "../../../domain/models/brick-management-report/brick-management-data";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import Endpoints from "../../../domain/endpoints";
import { fetchAutoCompleteLocation } from "../../../domain/useages/brick-management/fetch-auto-complete-location";
import { RemoteFetchAutoCompleteLocation } from "../../../data/usecases/brick-management/remote-fetch-auto-complete-location";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface FetchAutoCompleteLocationInterface {
  FetchAutoCompleteLocation: FetchAutoCompleteLocationType;
  FetchAutoCompleteLocationState: FetchState;
  fetchAutoCompleteLocation: Function;
}

const initialStates = {
  FetchAutoCompleteLocation: {} as FetchAutoCompleteLocationType,
  FetchAutoCompleteLocationState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchAutoCompleteLocationSlice: StateCreator<
  FetchAutoCompleteLocationInterface
> = (set) => ({
  ...initialStates,
  fetchAutoCompleteLocation: async (
    params: fetchAutoCompleteLocation.Params
  ) => {
  const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
  const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchAutoCompleteLocation = new RemoteFetchAutoCompleteLocation(
      `${BASE_URL}${Endpoints.FETCH_AUTO_COMPLETE_LOCATION}`,
      axiosHttpClient
    );

    set(() => ({ FetchAutoCompleteLocationState: FetchState.LOADING }));
    let result = await remoteFetchAutoCompleteLocation.fetch(params);
    set(() => ({
      FetchAutoCompleteLocation: result,
      FetchAutoCompleteLocationState: FetchState.SUCCESS,
    }));
  },
});
